import React from "react";
import styled from "@emotion/styled";

const Container = styled.div`
  text-align: center;
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  @media (min-width: 1024px) {
    flex-direction: row;
    align-items: stretch;
  }
`;
const LogoBackground = styled.div`
  background-color: black;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 48px 0;
  @media (min-width: 1024px) {
    width: 50%;
    min-height: 100vh;
    padding: 0;
  }
`;
const Logo = styled.img`
  width: 300px;
  margin-bottom: 24px;
  @media (min-width: 1024px) {
    margin-bottom: 0;
  }
`;
const ContentSection = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 100%;
  padding: 48px 20px;
  @media (min-width: 1024px) {
    width: 50%;
    min-height: 100vh;
    padding: 0 40px;
  }
`;
const Title = styled.h1`
  font-size: 3rem;
  color: #222;
  margin-bottom: 0.5em;
`;
const Subtitle = styled.h2`
  color: #555;
  margin-bottom: 0.5em;
`;
const Message = styled.p`
  color: #888;
  margin-top: 20px;
  font-size: 1.1rem;
`;
const HomeLink = styled.a`
  color: #007aff;
  text-decoration: underline;
  font-weight: 500;
`;

const NotFound = () => (
    <Container>
        <LogoBackground>
            <Logo src="/images/fullproof_logo_white.svg" alt="Fullproof Logo" />
        </LogoBackground>
        <ContentSection>
            <Title>404</Title>
            <Subtitle>Page Not Found</Subtitle>
            <Message>
                Sorry, the page you are looking for does not exist.<br />
                Please check the URL or return to the {" "}
                <HomeLink href="/">homepage</HomeLink>.
            </Message>
        </ContentSection>
    </Container>
);

export default NotFound;
